import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Container, Box, Typography, Button } from '@mui/material';
import iconB from '../assets/bot_4712139.png';
import gif from '../assets/1.gif'
import Loading from './Loading';
import { ClipLoader } from 'react-spinners';
import { display } from '@mui/system';




const Home = () => {
  const [animate, setAnimate] = useState(false);
  const location = useLocation();
  const [loading, setLoading] = useState(true);


  const handleButtonClick = () => {
    setAnimate(true);
    setTimeout(() => setAnimate(false), 300);
  };

  useEffect(() => {
    // Simulate an async operation, like fetching data
    const timer = setTimeout(() => {
      setLoading(false);
    }, 0); // Adjust the delay as needed

    return () => clearTimeout(timer);
  }, []);

  // if (loading) {
  //   return <Loading />;
  // }
  const styles = {
    spinnerContainer: {
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      marginTop: '250px'
    },
  };

  return (

    <Container sx={{ textAlign: 'center' }}>
      <div style={{ display: loading ? 'fixed' : 'none', ...styles.spinnerContainer }}>
        <ClipLoader size={50} color={"#123abc"} />
      </div>
      {/* <Box style={{ display: 'flex', justifyContent: 'flex-start' }}>
        <Button
          component={Link}
          to={location.pathname === '/chat_m' ? '/chat_m' : '/chat_m'}
          onClick={handleButtonClick}
          sx={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
            // padding: '8px 16px',
            borderRadius: '30px',
            backgroundColor: 'transparent',
            flexGrow: 1,
            justifyContent: 'space-between',
            width: '20%', // Half of the parent width

          }}
        >
          לדף הבית
          <img src={iconB} alt="Icon 2" style={{ width: '45px', height: '45px', border: 'solid 2px black', borderRadius: '30px' }} />
        </Button>
      </Box> */}
      <Box style={{ display: 'flex', justifyContent: 'flex-start' }}>
        <Button
          component={Link}
          to={location.pathname === '/chat_m' ? '/chat_m' : '/chat_m'}
          onClick={handleButtonClick}
          sx={{
            display: 'flex',
            flexDirection: 'column', // Change to column to stack items
            alignItems: 'center',
            textDecoration: 'none',
            borderRadius: '30px',
            backgroundColor: 'transparent',
            flexGrow: 1,
            justifyContent: 'center', // Center items vertically
            width: '20%', // Half of the parent width
          }}
        >
          <img
            src={iconB}
            alt="Icon 2"
            style={{
              width: '45px',
              height: '45px',
              border: 'solid 2px black',
              borderRadius: '30px',
              marginBottom: '8px', // Add some space between the image and text
            }}
          />
          חזרה
        </Button>
      </Box>

      <div variant="h2" style={{ color: '#a1a25d', fontFamily: 'MyCustomFont10', fontSize: '3.5rem' }}>
        <span id='header'>המק"ט</span>דתון
      </div>
      <div style={{ color: '#a1a25d', fontWeight: 'bold', fontFamily: 'MyCustomFont4', fontSize: '1.2rem' }}>
        כל המידע על המק"טים של הרבנות הצבאית בכף ידך.
      </div>
      <div style={{ color: '#a1a25d', fontFamily: 'MyCustomFont3', maxWidth: '21rem', margin: '0 auto', fontSize: '1.2rem' }}>
        חיל הרבנות הצבאית רוכש ומספק ציוד דת לכלל חיילי צבא ההגנה לישראל, וזאת על מנת לאפשר לכל חייל ולכל חיילת לשמור על אורחות חייהם, אמונתם ועולמם הרוחני במהלך השירות הצבאי.
      </div>

      {/* <Box sx={{ display: 'flex', justifyContent: 'center', width: '80%', margin: '0 auto', height: '7vh' }}> */}
      <div>
        <Button
          component={Link}
          to={location.pathname === '/search' ? '/' : '/search'}
          onClick={handleButtonClick}
          sx={{
            // display: 'flex',
            // alignItems: 'center',
            // textDecoration: 'none',
            // padding: '8px 16px',
            borderRadius: '30px',
            backgroundColor: '#a1a25d',
            // flexGrow: 1,
            // justifyContent: 'space-between',
            width: '23vh', // Half of the parent width
            marginTop: '1vh',
            marginBottom: '1vh',
            height: '40px'
          }}
        >
          <div style={{ backgroundColor: 'transparent', lineHeight: '1', height: '1vh', color: 'white', display: 'inline-block', padding: '10px 20px', borderRadius: '10px', marginBottom: '20px', fontFamily: 'MyCustomFont3', fontSize: '1.5rem' }}>
            התחל חיפוש
          </div>
        </Button>
      </div>
      <div>
        <img src={gif} alt="Car Animation" style={{ width: '250px', height: '200px', objectFit: 'cover', borderRadius: '20px' }} />
      </div>
      <div style={{ color: '#a1a25d', fontFamily: 'MyCustomFont3', maxWidth: '21rem', margin: '0 auto', fontSize: '1.2rem' }}>
        <p id='slogen'>  יחד, משרתים באמונה! יחד, שותפים לניצחון במלחמה!</p>
        <p id='slogen'>  כאן בשבילך, מדור ציוד דת ולוגיסטיקה</p>
      </div>
    </Container>
  );
};

export default Home;

